import type { RouteRecordRaw } from 'vue-router';
import { allSigninRoutes } from '@/pages/signin/routes';

export const signinRoutes: RouteRecordRaw = {
  path: '/auth',
  component: () => import('@/layouts/auth.vue'),
  meta: {
    requireAuth: false,
  },
  children: [
    ...allSigninRoutes,
  ],
};
